import { createActionGroup, props } from '@ngrx/store';

import { BaseZoneWithParentsFragment } from 'graphql.generated';

export const ZonesActions = createActionGroup({
	source: 'Zones',
	events: {
		'Zone Changed': props<{
			currentAppZone: BaseZoneWithParentsFragment
		}>(),
	},
});
